import { useMutation } from "react-query";
import getExchangeRate from "../services/getExchangeRate";

function useGetExchangeRate() {
  return useMutation(["getExchangeRate"], getExchangeRate);
}

export default useGetExchangeRate;
